<template>
  <md-dialog :md-active.sync="modFlujosContrato" :md-click-outside-to-close="false">
    <md-dialog-title class="text-center">
      {{ labels.title }}
    </md-dialog-title>

    <md-dialog-content>
      <div class="table col-md-18 mt-3">
        <table class="tblEstandar">
          <thead>
            <tr>
              <th class="thTbl">{{ labels.cuota }}</th>
              <th class="thTbl">{{ labels.valor }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in aFlujosContrato" :key="index">
              <td> {{ row.cuota}} </td>
              <td>
                <input type="number" class="form-control" v-model="row.valor">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="md-alignment-right">
          <button class="btn-save" @click="saveData">{{ labels.asignar }}</button>
    </md-dialog-actions>
  </md-dialog>
</template>


<script>

export default {
    name: 'ModFlujosContrato',
    props: ['modFlujosContrato','aFlujosContrato','valor_canon','numero_cuotas'],
    data: () => ({
	listFlujos : [],
    }),
    computed: {
        labels() {
            if (this.$store.state._language === "es-ES") {
                return {
                    title: 'Flujos del Contrato',
                    asignar: 'Aceptar',
                    close: 'Cerrar',
                    cuota: 'Cuota',
                    valor: 'Valor',
                }
            } else {
                return {
                    title: 'Add cost center',
                    asignar: 'Assign',
                    close: 'Close',
                    cuota: 'Cuota',
                    valor: 'Value',
                }
            }
        }
    },
    methods: {
        cierraModal() {
            this.$emit('cierraModalFC', false)
        },
        createEmptyRow() {
            return { selCentroCosto: '', porcentaje: '' }
        },
        saveData() {
		this.$emit('flujosContratoFC',this.aFlujosContrato)
		this.$toast.success('Flujo Asignado.')
		return;
        }
    },
}
</script>


<style>

</style>
